<template>
  <div class="navigation-items-fi">
    <div
      v-for="group in navigationGroups"
      :key="group.id"
      :class="{
        'navigation-items-fi__group': true,
        'navigation-items-fi__no-label': !group.groupLabel,
      }"
    >
      <span
        v-if="group.groupLabel"
        class="navigation-items-fi__group-label"
        >{{ group.groupLabel }}
      </span>
      <ul class="navigation-items-fi__list">
        <li
          v-for="item in group.groupList"
          :key="item.id"
          class="navigation-items-fi__list-item"
        >
          <a
            :href="item.url"
            :target="item.target ? item.target : null"
            :rel="item.target === '_blank' ? 'noopener noreferrer' : null"
            :data-test-2="item.label"
            data-test="navigation-group"
            class="navigation-items-fi__list-item--link"
          >
            {{ item.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import navigationMixin from '@/mixins/navigationMixin.vue';

export default {
  name: 'NavigationItemsFi',
  mixins: [navigationMixin],
  computed: {
    ...mapGetters({
      subElements: 'navigation/getSubElements',
    }),
    navigationGroups() {
      return this.getNavigationGroups(this.subElements);
    },
  },
};
</script>

<style scoped src="./navigation-items-fi" />
